import validate from "/builds/DEVV/russmedia-frontend-nuxt3/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/middleware/router.global.ts";
import manifest_45route_45rule from "/builds/DEVV/russmedia-frontend-nuxt3/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}